/**
 * 카카오 공유 링크에 실을 앱 실행 파라미터.
 *
 * 카톡은 링크를 자기 인앱 브라우저로 열기 때문에 iOS Universal Links·Android App Links가
 * 발동하지 않는다. 카톡에서 앱을 띄우는 정식 경로는 이 파라미터다 — 수신자가 링크를 누르면
 * 카톡이 `kakao<앱키>://kakaolink?<이 문자열>`로 앱을 실행하고, 앱은 `web_link`를 읽어
 * 그 경로를 WebView에 로드한다(app-container `useAppUrl`의 KAKAO_PREFIX 분기).
 *
 * 인코딩이 필수다 — 공유 URL에는 utm 쿼리가 붙어 있어(`?utm_source=…&utm_medium=…`)
 * 날것으로 넣으면 카톡이 넘긴 쿼리스트링을 앱이 파싱할 때 첫 `&`에서 잘린다.
 */
export const toKakaoExecutionParams = (shareUrl: string) =>
  `web_link=${encodeURIComponent(shareUrl)}`;
